module.exports = __webpack_public_path__ + "static/img/service_cont_01_zh.11b929e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_cont_01_zh.png
// module id = Haw3
// module chunks = 34